import { __awaiter, __extends, __generator } from "tslib";
import * as React from 'react';
import classNames from 'classnames';
import { fetchIcon } from '../../services/icon';
import { DefaultIcon } from './DefaultIcon';
var BadgeIcon = /** @class */ (function (_super) {
    __extends(BadgeIcon, _super);
    function BadgeIcon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            iconContent: '',
            hasLoadFailed: false,
        };
        _this.isWixMediaManagerIcon = function () { var _a; return new URL((_a = _this.props.badgeIcon) !== null && _a !== void 0 ? _a : '').hostname === BadgeIcon.WIX_STATICS_HOSTNAME; };
        _this.fetchIcon = function () { return __awaiter(_this, void 0, void 0, function () {
            var badgeIcon, newState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        badgeIcon = this.props.badgeIcon;
                        if (!(badgeIcon && this.isWixMediaManagerIcon())) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchIcon(badgeIcon, this.props.httpClient)];
                    case 1:
                        newState = _a.sent();
                        this.setState(newState);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.setIconRef = function (element) {
            _this.iconRef = element;
        };
        _this.setSvgAttributes = function (svg) {
            var bbox = svg.getBBox();
            var viewBox = [bbox.x, bbox.y, bbox.width, bbox.height].join(' ');
            svg.setAttribute('viewBox', viewBox);
            svg.setAttribute('width', bbox.width + "px");
            svg.setAttribute('height', bbox.height + "px");
        };
        return _this;
    }
    BadgeIcon.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchIcon()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BadgeIcon.prototype.componentDidUpdate = function (prevProps, prevState) {
        return __awaiter(this, void 0, void 0, function () {
            var svg, isSvgAttached;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(prevProps.badgeIcon !== this.props.badgeIcon)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchIcon()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.iconRef) {
                            return [2 /*return*/];
                        }
                        svg = this.iconRef.getElementsByTagName('svg')[0];
                        isSvgAttached = svg && svg.parentNode && svg.parentNode.offsetParent;
                        if (isSvgAttached) {
                            this.setSvgAttributes(svg);
                        }
                        if (prevState.iconContent !== this.state.iconContent && this.props.onLoadIcon) {
                            this.props.onLoadIcon();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BadgeIcon.prototype.render = function () {
        var _a = this.props, size = _a.size, layout = _a.layout, badgeIcon = _a.badgeIcon, hideDefaultIcon = _a.hideDefaultIcon;
        var iconClass = classNames('icon', size, layout);
        if (layout === 'name-only') {
            return null;
        }
        if (badgeIcon && !this.isWixMediaManagerIcon()) {
            return React.createElement("img", { className: iconClass, src: badgeIcon });
        }
        if (badgeIcon && !this.state.hasLoadFailed) {
            var innerHtml = { __html: this.state.iconContent };
            return React.createElement("div", { ref: this.setIconRef, className: iconClass, dangerouslySetInnerHTML: innerHtml });
        }
        if (layout !== 'icon-only') {
            return null;
        }
        if (!hideDefaultIcon) {
            return React.createElement(DefaultIcon, null);
        }
        return null;
    };
    BadgeIcon.WIX_STATICS_HOSTNAME = 'static.wixstatic.com';
    return BadgeIcon;
}(React.PureComponent));
export { BadgeIcon };
//# sourceMappingURL=BadgeIcon.js.map